import styled from "styled-components";
import {BlueButton} from "../buttons/ButtonStyles";
import CallSbAgainModal from "../modal/CallSbAgainModal";
import React, {useEffect, useState} from "react";
import {useSelector} from "react-redux";
import useFilterUser from "../../custom-hooks/useFilterUser";
import InputSearch from "../inputs/InputSearch";
import Projects from "./Projects";
import TabContainer from "../tab/TabContainer";
import useTab from "../../custom-hooks/useTab";
import {
    MONTH_FILTER, NEVER_UPDATED_FILTER,
    QUARTER_FILTER,
    SEMESTER_FILTER,
    TWO_WEEKS_FILTER,
    WEEK_FILTER, YEAR_FILTER
} from "../tab/filterTypes";

const DashboardCallAgain = () => {

    const {projects} = useSelector(state => state.projects)
    const [selectedProjectIds, setSelectedProjectIds] = useState([])
    const [isCallSbAgainModalOpen, setIsCallSbAgainModalOpen] = useState(false)
    const [sectionsMenu, setSectionsMenu] = useState([])
    const [projectsDisplayed, setProjectsDisplayed] = useState([])
    const [isChecked, setIsChecked] = useState(false)
    const {sections, toggleSection, activeTab} = useTab(sectionsMenu)

    const {
        query,
        setQuery,
    } = useFilterUser(projects)

    const [today] = useState(new Date())
    const callSbAgainHandler = (projectId) => {
        setSelectedProjectIds([projectId])
        setIsCallSbAgainModalOpen(true)
    }

    useEffect(() => {
        let selectedSection = sections.filter(s => s.state === true)[0] || {}
        let projectsArray = []
        let date = new Date(today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate());
        const retrieveMonths = (date, months) => {
            let newDate = new Date(date)
            newDate.setMonth(newDate.getMonth() - months)
            return newDate
        }
        const returnProjectsByDate = (date) => {
            let projectsArray = []
            let formattedDate = new Date(date)
            projects.forEach((project) => {
                if (project.lastUpdate !== null && project.advancement < 100) {
                    let projectDate = new Date(project.lastUpdate)
                    if (projectDate <= formattedDate) {
                        projectsArray.push(project)
                    }
                }
            })
            return projectsArray
        }
        if (Object.keys(selectedSection).length > 0) {
            let key = selectedSection.key
            if (key === WEEK_FILTER) {
                let dateOneWeekAgo = date.setDate(date.getDate() - 7)
                projectsArray = returnProjectsByDate(dateOneWeekAgo)
            } else if (key === TWO_WEEKS_FILTER) {
                let dateTwoWeeksAgo = date.setDate(date.getDate() - 14)
                projectsArray = returnProjectsByDate(dateTwoWeeksAgo)
            } else if (key === MONTH_FILTER) {
                projectsArray = returnProjectsByDate(retrieveMonths(today, 1))
            } else if (key === QUARTER_FILTER) {
                projectsArray = returnProjectsByDate(retrieveMonths(today, 4))
            } else if (key === SEMESTER_FILTER) {
                projectsArray = returnProjectsByDate(retrieveMonths(today, 6))
            } else if (key === YEAR_FILTER) {
                projectsArray = returnProjectsByDate(retrieveMonths(today, 12))
            } else {
                projectsArray = projects.filter(p => p.lastUpdate === null)
            }
            setProjectsDisplayed(projectsArray)

        }
    }, [projects, sections, today])


    useEffect(() => {
        setProjectsDisplayed(projects)
    }, [projects])

    useEffect(() => {
        let menu = []
        menu.push({key: WEEK_FILTER, label: "1 semaine", state: false,})
        menu.push({key: TWO_WEEKS_FILTER, label: "15 jours", state: false,})
        menu.unshift({key: MONTH_FILTER, label: "1 mois", state: true,})
        menu.push({key: QUARTER_FILTER, label: "1 trimestre", state: false,})
        menu.push({key: SEMESTER_FILTER, label: "1 semestre", state: false,})
        menu.push({key: YEAR_FILTER, label: "1 an", state: false,})
        menu.push({key: NEVER_UPDATED_FILTER, label: "Jamais mis à jour", state: false,})
        setSectionsMenu(menu)

    }, [])

    const displayModals = () => {
        if (isCallSbAgainModalOpen) {
            return (
                <CallSbAgainModal
                    handleModalStatus={setIsCallSbAgainModalOpen}
                    selectedItemIds={selectedProjectIds}
                    setMultipleSelectionProjectIds={setSelectedProjectIds}
                    setIsChecked={setIsChecked}
                />
            )
        }
    }

    return (
        <Container>
            <h2> Tableau de relance </h2>
            <div>
                <p className={"txt-align"}> Découvrez ici quand les projets ont été mis à jour. </p>
                <p>Vous pouvez relancer tous les projets en fonction de leur date de mise à jour, en les sélectionnant
                    individuellement ou en groupe</p>
            </div>

            <Section>
                <ContainerButton>
                    {selectedProjectIds.length > 0 &&

                        <Button onClick={() => callSbAgainHandler(selectedProjectIds, true)}>
                            <h6> Relancer {selectedProjectIds.length === 1 ? "le projet sélectionné" : "les projets sélectionnés"} </h6>
                        </Button>

                    }
                </ContainerButton>
                <TabContainer
                    selectedTab={activeTab}
                    children={sections}
                    toggleSection={toggleSection}
                />
                <InputSearch
                    setQuery={setQuery}
                    placeholder={"nom du projet, du pilote..."}
                />
                <Projects
                    projects={projectsDisplayed}
                    query={query}
                    multipleSelectionProjectIds={selectedProjectIds}
                    callSbAgainHandler={callSbAgainHandler}
                    setMultipleSelectionProjectIds={setSelectedProjectIds}
                    isChecked={isChecked}
                    setIsChecked={setIsChecked}
                />
            </Section>
            {displayModals()}
        </Container>
    )
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2em;
  padding-bottom: 1em;
  align-items: center;
  width: 100%;
  @media (min-width: 900px) {
    padding-left: 1em;
  }
`

const Section = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2em;
  width: 100%;
`

const Button = styled(BlueButton)`
  border-radius: 10px;
  padding: 0.5em;
  flex-grow: 0.3;

  h6 {
    font-size: 0.8rem;
    line-height: initial;
    text-align: center;
    flex-grow: 1;
  }
`

const ContainerButton = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1rem;
  width: 90%;


`

export default DashboardCallAgain;